import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ProjectService} from "src/app/services/project.service";
import {ProjectResponse} from "src/app/models/projects/projectResponse";
import {NgxSpinnerService} from "ngx-spinner";
import {FormArray, FormGroup} from "@angular/forms";
import {baseFile} from "../../../models/grantApplication/grantApplicationGetinfoResponse";
import {DatePipe} from "@angular/common";
import swal from "sweetalert2";


@Component({
  selector: "app-project-detail",
  templateUrl: "./project-detail.component.html",
  styleUrls: ['./project-detail.component.css', '../../../app.component.css'],
  providers: [DatePipe]
})
export class ProjectDetailComponent implements OnInit {

  files: baseFile[] = [];
  projectId: string = "";
  url: any;
  projectData: ProjectResponse = new ProjectResponse();
  protected granApplicationId?: string;
  protected fileForm: FormGroup = new FormGroup({
    documentDatas: new FormArray([]),
  });

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.route.params.subscribe(params => {
      this.projectId = params['id'];
    });
  }

  get documentDatas(): FormArray {
    return this.fileForm.get('documentDatas') as FormArray;
  }

  async ngOnInit(): Promise<void> {


    await this.spinner.show();
    Promise.all([]).then(() => {
      this.loadProject();
    }).finally(() => this.spinner.hide());
  }


  async loadProject() {
    await this.spinner.show();
    this.projectService.getProject(this.projectId).subscribe({
      next: async (res) => {
        if (res && res.result) {
          this.projectData = res.item ?? new ProjectResponse();
        } else {
          const errorMessage = res?.messages;
          await this.spinner.hide();
          swal.fire({
            title: "Error",
            text: errorMessage?.join(', ') || "An unexpected error occurred.",
            icon: "error",
          }).then(() => {

            this.router.navigate(['/funding-opportunities']);
          });
          return;
        }
        await this.spinner.hide();
      },
      error: async (err) => {
        console.error("Error loading project:", err);
        await this.spinner.hide();

        // Reported by HttpErrorInterceptor. The redirect used to hang off that dialog's promise;
        // it has to happen either way, because this page has no project left to show.
        this.router.navigate(['/funding-opportunities']);
      }
    });
  }


  onFileValueChanged($event: baseFile[]) {

    this.files = $event

  }


}
